'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateUserAge = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calculateUserAge = exports.calculateUserAge = function calculateUserAge(birthday) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)();
  return now.diff((0, _moment2.default)(birthday), 'years');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/clark-utils/lib/users/age/index.js
// module id = 586
// module chunks = 0